/**
 * The starter ship.
 *
 * What you are given when you lose a hull, and what you begin with. It is the
 * reason the trader no longer has to guarantee a shop full of parts: nobody is
 * ever stranded, because losing everything hands you something that flies.
 *
 * The design itself is a real one, drawn in the editor and baked in from
 * `starter.ship.json` — see `scripts/generate-starter.mjs`. Keeping it as an
 * exported design rather than a hand-written literal means it can be improved
 * the same way any other ship is: fly it, change it, export over the file.
 *
 * A player's own blueprint is never touched by any of this. Losing a hull costs
 * you the ship and what was aboard it, not the design, so reclaiming your real
 * one is a matter of affording it.
 */
import { STARTER_GRAPH, STARTER_NAME } from './starter.generated.js';
export { STARTER_NAME };
/**
 * The design, deep-copied on every call.
 *
 * Never handed out by reference. The hull built from it takes damage, and a
 * shared reference would write that damage into the template every player in
 * the game respawns with.
 */
export function starterDesign() {
    return {
        joints: STARTER_GRAPH.joints.map((joint) => ({ ...joint })),
        lines: STARTER_GRAPH.lines.map((line) => ({ ...line })),
        components: STARTER_GRAPH.components.map((component) => ({
            ...component,
            position: { ...component.position },
        })),
    };
}
//# sourceMappingURL=starter.js.map